import React from "react";
import { Page } from "../../../components/common";
import { useClient } from "../../../hooks";
import { get } from "lodash";
import { Alert } from "reactstrap";
import { handleNonFieldErrors } from "../util";
import { ParentalConsentForm } from "./components/ParentalConsentForm";
import { useParentalConsentFormQuery } from "./hooks/useParentalConsentFormQuery";

export const VolunteerParentalConsentFormView = ({ match }) => {
  const { id } = match.params;
  const url = `volunteer_parental_consent_forms/${id}`;
  const client = useClient();
  const { error, data, refetch } = useParentalConsentFormQuery(url);

  const container = (children) => (
    <Page title="Parental Consent for Child to Volunteer at Make Lunch">
      {children}
    </Page>
  );

  if (error && get(error, "response.status") === 404) {
    return container(
      <Alert color="warning">
        This Parental Consent form link is not valid.
      </Alert>
    );
  }

  if (!data) return null;

  async function onSubmit(x) {
    try {
      await client.patch(url, x);
    } catch (ex) {
      handleNonFieldErrors(ex);
    }
    await refetch();
  }

  const { submitted } = data;

  if (submitted) {
    return container(
      <>
        <h3 className="tw-font-medium tw-text-xl tw-mb-4">Thanks!</h3>
        <p>
          Thank you for taking the time to complete this Parental Consent form!
        </p>
        <p>The Make Lunch Team</p>
      </>
    );
  }

  return container(
    <>
      <ParentalConsentForm data={data} onSubmit={onSubmit} />
    </>
  );
};
